import React, { lazy, Suspense } from 'react';

const LazySubscriptionPaymentComponent = lazy(
  () => import('./subscription-payment.component')
);

const SubscriptionPaymentLazyComponent = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazySubscriptionPaymentComponent {...props} />
  </Suspense>
);

export default SubscriptionPaymentLazyComponent;
